import type React from 'react'
import type { Corners } from 'atoms/Label/Label.h'
import type { COLOR } from 'vars/index'

import { BorderOuterSC } from './BorderOuter.styled'

export interface IBorderOuter {
  children: React.ReactNode
  borders?: number[]
  borderColor?: COLOR
  borderColorGradient?: COLOR
  corners?: Corners
}

export const BorderOuter = ({
  children,
  borders,
  borderColor,
  borderColorGradient,
  corners,
}: IBorderOuter) => (
  <BorderOuterSC
    borders={borders}
    borderColor={borderColor}
    borderColorGradient={borderColorGradient}
    corners={corners}
  >
    {children}
  </BorderOuterSC>
)
